export function getEnvironment() {
    return typeof window === 'undefined' ? 'server' : 'browser';
}
